export function formatPriceWithRupeeSymbol(price: number): string {
  const formatted = Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  }).format(price)

  return formatted.replace(/\.00$/, "")
}
